/**
 * Fetch a published policy document (GET /api/policies/:policyType) for a policy modal. Checks the
 * HTTP status, validates the body against the boundary schema, and aborts an in-flight request
 * when the policy changes or the modal unmounts.
 */
import { useCallback, useEffect, useState } from 'react';
import { PolicyResponseSchema } from '@resida/api-types/policies';
export function usePolicyDocument(policyType) {
    const [attempt, setAttempt] = useState(0);
    const [state, setState] = useState({
        status: 'idle',
        document: null,
    });
    useEffect(() => {
        if (!policyType) {
            setState({ status: 'idle', document: null });
            return;
        }
        const controller = new AbortController();
        setState({ status: 'loading', document: null });
        fetch(`/api/policies/${policyType}`, { signal: controller.signal })
            .then(async (res) => {
            if (!res.ok)
                throw new Error(`Policy request failed with ${res.status}`);
            return PolicyResponseSchema.parse(await res.json());
        })
            .then((document) => {
            if (!controller.signal.aborted)
                setState({ status: 'ready', document });
        })
            .catch(() => {
            // Surfaced to the user as the modal's error state with a retry (not logged: the
            // public endpoint's failures are already logged server-side).
            if (!controller.signal.aborted)
                setState({ status: 'error', document: null });
        });
        return () => controller.abort();
    }, [policyType, attempt]);
    const retry = useCallback(() => setAttempt((n) => n + 1), []);
    return { ...state, retry };
}
//# sourceMappingURL=usePolicyDocument.js.map